import type { AppBuilder } from 'src/services/api/appBuilderApi';

/**
 * Deployed for preview/tab purposes — NOT draft/publish semantics, which the
 * backend derives from status. Mirrors the backend's IsPublishedToClients: a
 * saved deploymentUrl keeps the last successful deployment live while the
 * shared build status changes under teammates' turns and republishes, so
 * status alone must not decide this.
 */
export const isAppBuilderDeployed = (
  builder: Pick<AppBuilder, 'status' | 'deploymentUrl'> | undefined,
): boolean =>
  !!builder &&
  (builder.status === 'deployed' ||
    builder.status === 'installed' ||
    Boolean(builder.deploymentUrl));
